// Defer iframes that load at zero dimensions (inside closed accordions or hidden behind cover images)
// so YouTube initialises at full size and serves a high-res thumbnail
document.querySelectorAll('iframe.video__asset-iframe').forEach(iframe => {
  const inAccordion = !!iframe.closest('details')
  const hasCoverImage = !!iframe.closest('.cover-image')
  if (inAccordion || hasCoverImage) {
    iframe.dataset.src = iframe.src
    iframe.removeAttribute('src')
  }
})

document.querySelectorAll('details').forEach(details => {
  details.addEventListener('toggle', () => {
    if (details.open) {
      details.querySelectorAll('iframe.video__asset-iframe[data-src]').forEach(iframe => {
        // Skip cover-image iframes — the click handler loads them with autoplay instead
        if (iframe.closest('.cover-image')) return
        iframe.src = iframe.dataset.src
        delete iframe.dataset.src
      })
    }
  })
})

document.querySelectorAll(".video__button").forEach(function (button) {
  button.addEventListener("click", function () {
    const parent = button.closest(".video__frame");
    const videoEl = button.parentElement.querySelector(".video__asset");

    if (parent) {
      parent.classList.add("video__playing");
    }

    button.hidden = true;

    if (!videoEl) return;

    // if uploaded video
    if (videoEl.classList.contains("video__asset--uploaded")) {
      videoEl.play();
    }
    // else youtube or vimeo video
    else {
      const src = videoEl.dataset.src || videoEl.src;
      videoEl.src = src + "?autoplay=1";
    }
  });
});